import React, { FC, useMemo, useCallback, memo } from 'react';
import { useLazyQuery } from '@apollo/client';
import _filter from 'lodash/filter';
import _sortBy from 'lodash/sortBy';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import ErrorMessage from '@minecraft.error-message';
import { FilterData } from '../../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../../shared/utils';
import { QUERY_CONFLICTS } from '../FilterBasicCollectionGraphQL';

type Props = FilterData;

const Conflicts: FC<Props> = ({ name, label }) => {
  const [getConflicts, { data, loading, error }] = useLazyQuery(QUERY_CONFLICTS);

  const handleConflictsFetch = useCallback((): void => {
    if (!data) {
      getConflicts();
    }
  }, [data]);

  const conflictsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(
        _filter(data?.conflicts, (conflict) => conflict.enabled),
        'sortOrder'
      ),
      'name'
    );
  }, [data?.conflicts]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withSelectAll
      isMultipleSelect
      isLoading={loading}
      name={name}
      toggleLabel={label}
      options={conflictsOptions}
      onOptionsFetch={handleConflictsFetch}
    />
  );
};

export default memo(Conflicts);
